//changed due to package upgrade
import React from 'react';
import Drawer from '@mui/material/Drawer';
import Card from '@mui/material/Card';
import {
  Box,
  drawerClasses,
  Slide,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import PropTypes from 'prop-types';

const AppSidebar = (props) => {
  const { isAppDrawerOpen, sidebarContent, toggleNavCollapsed } = props;
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Slide direction='right' in mountOnEnter unmountOnExit>
      <Box
        sx={{
          height: '100%',
          width: {
            lg: 280,
          },
        }}
      >
        {!isLgUp && (

          <Drawer
            open={isAppDrawerOpen}
            onClose={toggleNavCollapsed}
            sx={{
              position: 'absolute',
              [`& .${drawerClasses.paper}`]: {
                width: 280,
                '& .listItem': {
                  zIndex: 1305,
                },
              },
            }}
          >
            {sidebarContent}
          </Drawer>
        )}

          {!isLgDown && (

          <Card style={{ height: '100%' }}>{sidebarContent}</Card>

          )}
      </Box>
    </Slide>
  );
};

export default AppSidebar;

AppSidebar.propTypes = {
  isAppDrawerOpen: PropTypes.bool,
  toggleNavCollapsed: PropTypes.func,
  sidebarContent: PropTypes.node,
};
